import { AbstractContentState, useCmsContent } from '@cp-shared-19/frontend-integration';
import { fetchLogout } from './LogoutSlice';
import { LogoutContentSelector } from './LogoutContentSelector';
import { Logout } from 'cpes-common';

export function useLogout(): AbstractContentState<Logout> {
    return useCmsContent(fetchLogout, LogoutContentSelector);
}
